export default {
      id: "link-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.svg#link",
      toString: function () {
        return this.url;
      }
    }